import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../config"; // Apna correct path lagana

function AdminDeletionRequests() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const token = localStorage.getItem("token"); // Admin ka token

    // Fetch Requests
    const fetchRequests = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_URL}/api/admin/deletion-requests`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.success) {
                setRequests(res.data.data);
            }
        } catch (err) {
            console.error("Failed to fetch deletion requests", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRequests();
        // eslint-disable-next-line
    }, []);

    // 🔴 Approve Delete (Permanent)
    const handlePermanentDelete = async (userId, userName) => {
        const confirmDelete = window.confirm(`⚠️ WARNING: Are you sure you want to PERMANENTLY delete ${userName}'s account? This cannot be undone.`);
        
        if (confirmDelete) {
            try {
                const res = await axios.delete(`${API_URL}/api/admin/user/${userId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (res.data.success) {
                    alert("User permanently deleted.");
                    fetchRequests(); // Refresh table
                }
            } catch (err) {
                alert("Failed to delete user.");
            }
        }
    };

    // ⚪ Cancel Request
    const handleCancelRequest = async (userId) => {
        try {
            const res = await axios.put(`${API_URL}/api/admin/user/${userId}/cancel-deletion`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.success) {
                alert("Deletion request cancelled.");
                fetchRequests(); // Refresh table
            }
        } catch (err) {
            alert("Failed to cancel request.");
        }
    };

    return (
        <div style={{ minHeight: "100vh", background: "#f4f6f9", paddingBottom: "50px", fontFamily: "'Poppins', sans-serif" }}>
            
            {/* Header */}
            <div className="bg-white shadow-sm p-4 mb-4 d-flex justify-content-between align-items-center" style={{ borderBottom: "4px solid #dc3545" }}>
                <div>
                    <h4 className="fw-bolder mb-0 text-danger"><i className="bi bi-exclamation-octagon-fill me-2"></i>Account Deletion Requests</h4>
                    <p className="text-muted small mb-0 mt-1">Review and process users requesting permanent account deletion</p>
                </div>
                <button 
                    className="btn btn-light shadow-sm d-flex align-items-center gap-2 fw-bold text-muted" 
                    onClick={fetchRequests} disabled={loading}
                >
                    <i className={`bi bi-arrow-clockwise fs-5 text-danger ${loading ? 'spin-anim' : ''}`}></i> 
                    {loading ? 'Refreshing...' : 'Refresh'}
                </button>
            </div>

            <div className="container-fluid px-4">
                <div className="card border-0 shadow-sm border-danger border-top border-3" style={{ borderRadius: "15px", overflow: "hidden" }}>
                    <div className="card-body p-0">
                        
                        {loading ? (
                            // SHIMMER LOADER
                            <div className="table-responsive p-3">
                                {[1, 2, 3].map(i => (
                                    <div key={i} className="placeholder-glow mb-3 d-flex gap-3">
                                        <span className="placeholder col-2 bg-secondary opacity-10 rounded" style={{ height: "40px" }}></span>
                                        <span className="placeholder col-4 bg-secondary opacity-10 rounded" style={{ height: "40px" }}></span>
                                        <span className="placeholder col-3 bg-secondary opacity-10 rounded" style={{ height: "40px" }}></span>
                                    </div>
                                ))}
                            </div>
                        ) : requests.length === 0 ? (
                            <div className="text-center p-5 text-muted">
                                <i className="bi bi-shield-check display-1 text-success opacity-50 mb-3"></i>
                                <h5 className="fw-bold">No Deletion Requests!</h5>
                                <p>All users are happy and playing.</p>
                            </div>
                        ) : (
                            <div className="table-responsive custom-scrollbar" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                                <table className="table table-hover align-middle mb-0">
                                    <thead style={{ position: "sticky", top: 0, zIndex: 10, background: "#fff5f5", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
                                        <tr>
                                            <th className="text-danger small fw-bold px-4 py-3 border-0">USER INFO</th>
                                            <th className="text-danger small fw-bold py-3 border-0">REQUEST DATE</th>
                                            <th className="text-danger small fw-bold text-end px-4 py-3 border-0">ACTIONS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {requests.map((reqUser) => (
                                            <tr key={reqUser._id} className="hover-bg-light">
                                                <td className="px-4 py-3">
                                                    <div className="fw-bold text-dark">{reqUser.name}</div>
                                                    <div className="small text-muted">{reqUser.email}</div>
                                                    <div className="small text-muted">Wallet: ₹{reqUser.walletBalance || 0}</div>
                                                </td>
                                                <td className="py-3 text-muted small fw-semibold">
                                                    {new Date(reqUser.deletionRequestedAt).toLocaleString()}
                                                </td>
                                                <td className="text-end px-4 py-3">
                                                    <div className="d-flex gap-2 justify-content-end">
                                                        <button 
                                                            className="btn btn-sm btn-outline-secondary fw-bold"
                                                            onClick={() => handleCancelRequest(reqUser._id)}
                                                        >
                                                            Cancel Request
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-danger fw-bold shadow-sm"
                                                            onClick={() => handlePermanentDelete(reqUser._id, reqUser.name)}
                                                        >
                                                            <i className="bi bi-trash-fill me-1"></i> Permanently Delete
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <style>{`
                .hover-bg-light:hover { background-color: #fffafb; }
                .spin-anim { animation: spin 1s linear infinite; }
                @keyframes spin { 100% { transform: rotate(360deg); } }
                .custom-scrollbar::-webkit-scrollbar { width: 6px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #dc3545; border-radius: 10px; }
            `}</style>
        </div>
    );
}

export default AdminDeletionRequests;